module.exports = __webpack_public_path__ + "img/background.7862bd5b.png";